import { createSvgIcon } from "@mui/material";

export const CheckIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline points="9 11 12 14 22 4"></polyline>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
  </svg>,
  "CheckReciept"
);

export const AmazonIcon = createSvgIcon(
  <svg viewBox="0 0 40 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.4203 21.433L29.2495 19.6237C28.8887 19.0661 28.6968 18.416 28.6968 17.7519V10.1519C28.6968 7.11831 28.9166 0.655182 20.2553 0.655182C13.2093 0.655182 11.0305 4.4102 10.3568 6.73272C10.0893 7.65477 10.7178 8.59363 11.6729 8.69217L14.4038 8.97393C15.0466 9.04022 15.663 8.69904 15.9418 8.11606C16.4712 7.00877 17.394 5.35974 20.2416 5.35974C21.3447 5.35974 22.8959 5.82632 22.8959 7.19052C22.8959 9.16995 22.8933 10.1081 22.8933 10.1081C22.9007 10.5212 22.5679 10.8601 22.1547 10.8601H19.4854C17.4713 10.8601 9.81787 11.893 9.81787 19.5464C9.81787 27.1998 17.9391 26.3192 18.4783 26.1928C19.4843 25.9571 21.3691 25.2687 23.1405 23.5796C23.4381 23.2958 23.9129 23.3205 24.1714 23.6404L25.6018 25.4104C26.1579 26.0985 27.1807 26.1708 27.828 25.568L30.1793 23.378C30.7205 22.8738 30.8221 22.054 30.4203 21.433ZM18.6796 21.0065C15.9606 21.0065 16.0381 18.5482 16.6655 17.3812C17.2525 16.2892 18.8034 14.3536 22.9671 14.2217L23.0036 16.253C23.0308 17.7629 22.3361 19.2132 21.101 20.0822C20.3358 20.6208 19.5008 21.0065 18.6796 21.0065Z"
      fill="black"
    />
    <path
      d="M0.759324 27.9949C0.345824 27.6212 0.7958 26.9595 1.29568 27.2057C4.8089 28.9364 11.4229 31.612 18.7339 31.612C26.2051 31.612 32.4554 29.8274 35.6012 28.7261C36.1127 28.547 36.4813 29.2165 36.0602 29.5577C33.5644 31.5791 28.2046 34.7063 18.9303 34.7063C9.69077 34.7063 3.68904 30.6424 0.759324 27.9949Z"
      fill="#FF9900"
    />
    <path
      d="M32.3086 26.9056C33.2832 26.1841 35.7046 24.9401 39.3234 26.0278C39.6559 26.1277 39.8826 26.4354 39.8851 26.7826C39.8939 27.9698 39.6381 30.7572 37.3141 33.0736C37.1527 33.2344 36.881 33.0765 36.9407 32.8566C37.3376 31.395 38.1445 28.26 37.8885 27.8226C37.595 27.3212 33.9274 27.2973 32.4414 27.3084C32.2246 27.3101 32.1344 27.0346 32.3086 26.9056Z"
      fill="#FF9900"
    />
  </svg>,
  "AmazonIcon"
);

export const NamshiIcon = createSvgIcon(
  <svg
    height="35"
    viewBox="0 0 110 51"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-666.000000, -40.000000)"
        fill="#000"
        fill-rule="nonzero"
      >
        <g id="Group-6" transform="translate(666.000000, 40.000000)">
          <polygon
            id="Rectangle-path"
            transform="translate(62.516395, 1.881435) rotate(-89.848723) translate(-62.516395, -1.881435) "
            points="60.7898464 0.120015273 64.2429269 0.120031553 64.2429434 3.64285401 60.7898629 3.64283773"
          ></polygon>
          <polygon
            id="Rectangle-path"
            transform="translate(108.083123, 1.995945) rotate(-89.848723) translate(-108.083123, -1.995945) "
            points="106.356574 0.234525458 109.809655 0.234541738 109.809671 3.75736419 106.356591 3.75734791"
          ></polygon>
          <polygon
            id="Rectangle-path"
            transform="translate(54.573603, 1.847225) rotate(-89.848723) translate(-54.573603, -1.847225) "
            points="52.8470549 0.0858055636 56.3001354 0.0858218441 56.3001519 3.6086443 52.8470714 3.60862802"
          ></polygon>
          <polygon
            id="Rectangle-path"
            transform="translate(5.299327, 23.491670) rotate(-89.848723) translate(-5.299327, -23.491670) "
            points="3.57277818 21.7302503 7.02585868 21.7302666 7.02587526 25.253089 3.57279476 25.2530727"
          ></polygon>
          <polygon
            id="Rectangle-path"
            transform="translate(46.637993, 1.823397) rotate(-89.848723) translate(-46.637993, -1.823397) "
            points="44.9114446 0.0619779927 48.3645251 0.0619942732 48.3645417 3.58481673 44.9114612 3.58480045"
          ></polygon>
          <polygon
            id="Rectangle-path"
            transform="translate(12.104230, 23.505748) rotate(-89.848723) translate(-12.104230, -23.505748) "
            points="10.3776818 21.7443283 13.8307623 21.7443446 13.8307789 25.2671671 10.3776984 25.2671508"
          ></polygon>
          <path
            d="M93.9449541,20.0853577 L106.477064,20.1224223 L109.963303,20.1409547 L110,5.35216516 L106.513761,5.33363284 L106.477064,16.601282 L93.9633028,16.5642173 C93.1743119,12.5241721 89.6513761,9.46633968 85.412844,9.44780736 C81.1926606,9.42927505 77.6697248,12.4685751 76.8440367,16.4715558 L64.3486239,16.4344911 L64.3853211,5.20390662 L60.8990826,5.1853743 L60.8623853,16.4159588 L56.3853211,16.4159588 L56.4220183,5.1853743 L52.9357798,5.16684198 L52.8990826,16.3974265 L48.3853211,16.3788942 L48.4220183,5.12977735 L44.9357798,5.11124503 L44.8990826,16.3603619 L32.9724771,16.3232972 L33.0091743,5.09271271 L28.4036697,5.0741804 C24.1834862,5.05564808 20.7522936,8.48412685 20.733945,12.690963 C20.733945,12.690963 20.7155963,16.2862326 20.7155963,16.2862326 L3.50458716,16.2306356 L3.50458716,16.193571 C3.52293578,11.9496702 6.95412844,8.52119148 11.1743119,8.52119148 L13.8348624,8.5397238 L13.853211,5.01858344 L11.1926606,5.00005112 C5.04587156,4.98151881 0.0366972477,10.0037769 0.0183486239,16.1750387 L0,19.7332437 L24.2018349,19.8073729 L24.2201835,12.6724306 C24.2201835,10.4114879 26.0917431,8.57678843 28.3853211,8.57678843 L29.4862385,8.57678843 L29.4495413,19.8073729 L76.8256881,19.9185668 C77.6330275,23.9400798 81.1376147,26.9793799 85.3577982,26.9979122 C89.5779817,27.0905738 93.1009174,24.0883383 93.9449541,20.0853577 Z M85.3944954,23.5509011 C82.5137615,23.5509011 80.1651376,21.1602321 80.1651376,18.2506583 C80.1651376,15.3410844 82.5321101,12.9689477 85.412844,12.9689477 C88.293578,12.9689477 90.6422018,15.3596167 90.6422018,18.2691906 C90.6238532,21.1972968 88.2752294,23.5509011 85.3944954,23.5509011 Z"
            id="Shape"
          ></path>
          <path
            d="M30.4951024,31 L22,50.9447514 L25.4550312,50.9631676 L27.4318789,46.174954 L36.4968833,46.1933702 L38.4381122,50.9815838 L42,51 L33.6117542,31.0184162 L30.4951024,31 Z M28.6963491,43.0810313 L32.0089047,35.1620626 L35.3036509,43.0994475 L28.6963491,43.0810313 Z"
            id="Shape"
          ></path>
          <polygon
            id="Shape"
            points="3.39638682 36.7645968 14.0913921 50.9814643 16.9458023 51 17 31.0370714 13.639745 31.0370714 13.6036132 44.8276182 3.21572795 31 0.0541976621 31 0 50.944393 3.36025505 50.9629286"
          ></polygon>
          <polygon
            id="Shape"
            points="63.9641509 51 64 31.055607 60.3971698 31.0370714 54.5 40.4531974 48.6566038 31 45.0358491 31 45 50.944393 48.3339623 50.9629286 48.3698113 36.7089898 54.3745283 46.0695088 54.4820755 46.0695088 60.6122642 36.6904541 60.5584906 51"
          ></polygon>
          <polygon
            id="Rectangle-path"
            transform="translate(107.974877, 40.698748) rotate(-89.848723) translate(-107.974877, -40.698748) "
            points="98.145465 38.9372902 117.804272 38.9373829 117.804289 42.4602053 98.1454815 42.4601126"
          ></polygon>
          <polygon
            id="Shape"
            points="99.603352 39.3225209 90.4145251 39.3039852 90.4324022 31 87.0536313 31 87 50.944393 90.396648 50.9629286 90.4145251 42.5477294 99.5854749 42.5848007 99.5675978 50.9814643 102.946369 51 103 31.0370714 99.6212291 31.0370714"
          ></polygon>
          <path
            d="M75.7769784,39.4552988 C72.0719424,38.5519663 71.1906475,37.8835003 71.1906475,36.3659017 C71.1906475,35.0651029 72.3597122,34.0353039 74.3561151,34.0353039 C76.118705,34.0353039 77.8633094,34.7399032 79.6079137,36.040702 L81.442446,33.4571711 C79.4820144,31.8673059 77.2517986,31.0001068 74.4280576,31.0001068 C70.5791367,30.9820401 67.8093525,33.258438 67.8093525,36.6549681 C67.7913669,40.2682981 70.1115108,41.4968302 74.2302158,42.5085626 C77.8273381,43.3576952 78.6007194,44.0984278 78.6007194,45.5256931 C78.6007194,47.025225 77.2697842,48.0008241 75.1654676,47.9827575 C72.7553957,47.9827575 70.9028777,47.0613583 69.0503597,45.4353599 L67,47.8743576 C69.3201439,49.9700889 72.1079137,50.999888 75.0755396,50.999888 C79.1402878,51.0179546 82,48.8499567 82,45.1824268 C82,41.9304298 79.8597122,40.4670312 75.7769784,39.4552988 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>,
  "NamshiIcon"
);

export const VperfumeIcon = createSvgIcon(
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="300.000000pt"
    height="134.000000pt"
    viewBox="0 0 300.000000 134.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    {" "}
    <g
      transform="translate(0.000000,134.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      {" "}
      <path d="M1440 1300 l0 -40 45 0 45 0 0 40 0 40 -45 0 -45 0 0 -40z" />{" "}
      <path d="M1370 1155 c10 -16 42 -73 72 -126 l54 -97 22 39 22 38 -50 85 c-49 83 -50 84 -94 87 l-45 4 19 -30z" />{" "}
      <path d="M1334 900 c106 -185 164 -276 169 -268 4 7 69 119 143 248 75 129 145 250 156 268 l20 32 -45 0 -45 0 -118 -206 c-82 -144 -121 -202 -126 -193 -5 8 -58 101 -119 207 l-111 192 -43 0 -43 0 162 -280z" />{" "}
      <path d="M1558 1136 c15 -24 30 -41 33 -38 3 4 16 24 28 45 l23 37 -56 0 -55 0 27 -44z" />{" "}
      <path d="M0 352 c0 -11 6 -22 13 -25 10 -4 12 -21 9 -66 -3 -46 0 -67 12 -86 15 -23 15 -28 1 -47 -8 -13 -15 -35 -15 -50 0 -16 -4 -28 -10 -28 -5 0 -10 -9 -10 -20 0 -16 7 -20 30 -20 30 0 30 1 30 55 l0 55 45 0 c92 0 145 41 153 119 4 45 2 52 -31 87 l-35 39 -96 3 c-90 4 -96 3 -96 -16z m180 -62 c11 -11 20 -31 20 -45 0 -41 -33 -65 -90 -65 l-50 0 0 65 0 65 50 0 c37 0 55 -5 70 -20z" />{" "}
      <path d="M405 190 l0 -180 103 0 102 0 0 31 0 31 -70 -4 -70 -3 0 48 0 47 70 0 70 0 0 30 0 30 -72 0 -73 0 0 45 0 45 73 0 72 0 0 30 0 30 -102 0 -103 0 0 -180z" />{" "}
      <path d="M755 191 l0 -181 33 0 34 0 -4 55 -3 55 32 0 c28 0 37 -7 63 -47 16 -27 31 -52 33 -56 1 -5 19 -7 39 -5 l36 3 -39 57 -38 57 29 21 c60 43 58 148 -3 194 -23 17 -46 22 -120 24 l-92 4 0 -181z m177 102 c22 -20 23 -70 1 -95 -11 -13 -30 -18 -67 -18 l-51 0 0 65 0 65 49 0 c32 0 56 -6 68 -17z" />{" "}
      <path d="M1170 190 l0 -180 30 0 30 0 0 75 0 75 70 0 70 0 0 30 0 30 -70 0 -70 0 0 45 0 45 70 0 70 0 0 30 0 30 -100 0 -100 0 0 -180z" />{" "}
      <path d="M1511 278 c1 -160 11 -207 47 -239 29 -26 40 -29 100 -29 122 0 142 32 142 225 l0 135 -30 0 -30 0 0 -130 c0 -126 -1 -132 -25 -155 -32 -33 -83 -34 -113 -2 -20 21 -22 34 -22 155 l0 132 -35 0 -35 0 1 -92z" />{" "}
      <path d="M1965 190 l0 -180 34 0 34 0 -6 121 c-5 103 -4 119 8 109 8 -7 17 -20 20 -31 5 -14 16 -19 45 -19 l39 0 -57 90 c-51 80 -60 90 -87 90 l-30 0 0 -180z" />{" "}
      <path d="M2230 190 l0 -180 30 0 30 0 0 180 0 180 -30 0 -30 0 0 -180z" />{" "}
      <path d="M2445 190 l0 -180 103 0 102 0 0 31 0 31 -70 -4 -70 -3 0 48 0 47 70 0 70 0 0 30 0 30 -70 0 -70 0 0 45 0 45 70 0 70 0 0 30 0 30 -102 0 -103 0 0 -180z" />{" "}
      <path d="M2824 356 c-35 -16 -59 -64 -50 -101 8 -31 37 -58 103 -96 55 -32 73 -60 52 -85 -19 -23 -82 -14 -94 13 -8 19 -57 37 -69 25 -9 -8 16 -60 39 -82 19 -18 35 -23 78 -22 65 0 93 16 108 59 17 52 -7 92 -85 142 -72 45 -85 63 -65 87 18 22 62 14 74 -13 7 -17 18 -23 42 -23 38 0 38 0 19 45 -24 57 -88 79 -152 51z" />{" "}
    </g>
  </svg>,
  "VPerfumeIcon"
);

export const SephoraIcon = createSvgIcon(
  `<svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 642 130.5"><style>.st0{fill-rule:evenodd;clip-rule:evenodd}</style><path d="M66.6 30.2s-.2.7-3.4 9.6c-9.1-7.5-24.5-7-24.5 4.6 0 13.6 32 11.9 31 36.1-.8 19.4-24 23.9-41.8 14.5 1.6-3.4 3.2-6.7 4.3-9.4 13.5 8.2 25.1 4.5 27.1-2.2C64.5 65.2 28 70.8 28 45.1c0-10.9 12.2-27.7 38.6-14.9M103.6 27h44.7s-.1 3.9 0 9.4h-33.5v19.3h23.7c-.1 3.9 0 6.9 0 8.9h-23.7v24.1h33.5v9.2h-44.6l-.1-70.9zM206 27.1c-3.9-.1-12.2-.1-19.2-.1v71H198V71.1c2.8 0 8.5-.2 13.2-.3 6.4-.2 23.4-3.3 23.2-22.8-.1-21.9-24.4-20.8-28.4-20.9m-.6 34.7H198V36.2h6.3c2.9 0 20-1.3 20.5 11.9.6 13-12.8 13.7-19.4 13.7M503.8 98h13.5l-22.4-31.8c6-2.2 13-7.4 12.1-19.1-1.6-21.1-22.1-19.5-26.5-19.7-3.7-.2-11.7-.3-18.6-.2V98h11.2V68.1c3.7 0 5-.1 10.6-.2L503.8 98zM480 59.9c-2.5 0-4.4 0-6.9-.1V35.9h5.8c2.7 0 17.4-.8 18.6 10.7C499 60.3 483 59.9 480 59.9M313 55.3V27.4h10.9v70.8H313V64.6h-36.3v33.6h-10.9V27.4h10.9v27.9z"></path><path class="st0" d="M567.5 27.2h12.9l25.5 71.1h-11.4s-2.5-7.2-5.9-16.7l-28.7.2s-1.2 3.7-4.6 16.5h-11l23.2-71.1m-5 46.4l23.1-.1-11.7-35h-.2l-11.2 35.1zM392.8 35.4c-16.6 0-26 12.2-26 27.3s9.3 27.3 26 27.3 26-12.2 26-27.3-9.5-27.3-26-27.3m0-10.2c-22.6 0-37.3 16.8-37.3 37.4 0 20.7 14.7 37.4 37.3 37.4 22.6 0 37.3-16.8 37.3-37.4 0-20.7-14.7-37.4-37.3-37.4"></path></svg>`,
  "SephoraIcon"
);

export const NikeUaeIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="19"
    viewBox="0 0 54 19"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.2501 0.429932L14.8551 16.7166C11.6584 18.0729 8.96926 18.7495 6.80218 18.7495C4.36385 18.7495 2.5876 17.8891 1.49676 16.1712C0.0821799 13.9574 0.700513 10.3903 3.12718 6.62785C4.56801 4.42868 6.39968 2.41035 8.18468 0.479515C7.76468 1.16202 4.0576 7.33077 8.11176 10.2358C8.91385 10.8191 10.0543 11.1049 11.4572 11.1049C12.583 11.1049 13.8751 10.9212 15.2955 10.5508L53.2501 0.429932Z"
      fill="#111111"
    />
  </svg>,
  "NikeUaeIcon"
);

export const SSsportUaeIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="90" height="37">
    <path
      d="M13.9 20.294a7.272 7.272 0 01-1.49-4.407c0-4.048 3.305-7.34 7.368-7.34a7.37 7.37 0 016.027 3.13l6.943-5.027A15.939 15.939 0 0019.778 0C10.971 0 3.831 7.112 3.831 15.887c0 3.534 1.16 6.798 3.12 9.436l6.948-5.029zm11.898-8.618l-6.949 5.03a7.276 7.276 0 011.49 4.407c0 4.047-3.305 7.34-7.368 7.34a7.368 7.368 0 01-6.026-3.13L0 30.35A15.941 15.941 0 0012.97 37c8.808 0 15.947-7.112 15.947-15.887 0-3.534-1.16-6.799-3.12-9.437zm9.779 13.647l6.948-5.029a7.272 7.272 0 01-1.49-4.407c0-4.048 3.306-7.34 7.368-7.34a7.368 7.368 0 016.027 3.13l6.945-5.027A15.94 15.94 0 0048.403 0c-8.806 0-15.945 7.112-15.945 15.887 0 3.534 1.16 6.798 3.119 9.436zm18.848-13.647l-6.95 5.03a7.277 7.277 0 011.49 4.407c0 4.047-3.305 7.34-7.368 7.34a7.368 7.368 0 01-6.026-3.13l-6.945 5.027A15.94 15.94 0 0041.596 37c8.808 0 15.947-7.112 15.947-15.887 0-3.534-1.16-6.799-3.118-9.437zM77.03 0c-8.807 0-15.947 7.112-15.947 15.887 0 3.534 1.16 6.798 3.12 9.436l6.948-5.029a7.278 7.278 0 01-1.49-4.407c0-4.048 3.306-7.34 7.37-7.34 2.49 0 4.692 1.24 6.025 3.13L90 6.65A15.939 15.939 0 0077.03 0zm-.929 16.706a7.27 7.27 0 011.49 4.407c0 4.047-3.304 7.34-7.367 7.34a7.369 7.369 0 01-6.027-3.13l-6.945 5.027A15.942 15.942 0 0070.224 37c8.806 0 15.946-7.112 15.946-15.887a15.78 15.78 0 00-3.12-9.437l-6.949 5.03z"
      fill="#F4B72D"
      fill-rule="evenodd"
    />
  </svg>,
  "SSsportUaeIcon"
);

export const NoonUaeIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="173"
    height="48"
    viewBox="0 0 173 48"
    fill="none"
  >
    <path
      d="M161.706 9.67833C158.639 9.67833 155.855 10.676 153.72 12.5128L153.105 10.3357H147.692V37.7063H154.573V22.8345C154.573 19.669 156.695 16.4615 160.746 16.4615C163.916 16.4615 165.804 18.6946 165.804 22.4289V37.711H172.685V21.9254C172.685 14.4849 168.378 9.67833 161.706 9.67833ZM106.709 24C106.709 28.3683 103.86 31.5385 99.9301 31.5385C96 31.5385 93.1515 28.3683 93.1515 24C93.1515 19.6317 96 16.4615 99.9301 16.4615C103.855 16.4615 106.709 19.6317 106.709 24ZM99.9254 9.67833C92.2098 9.67833 86.1632 15.9674 86.1632 23.9953C86.1632 32.0233 92.2051 38.317 99.9254 38.317C107.641 38.317 113.688 32.028 113.688 23.9953C113.688 15.9674 107.646 9.67833 99.9254 9.67833ZM136.779 24C136.779 28.3683 133.925 31.5385 130 31.5385C126.075 31.5385 123.221 28.3683 123.221 24C123.221 19.6317 126.075 16.4615 130 16.4615C133.93 16.4615 136.779 19.6317 136.779 24ZM130 9.67833C122.284 9.67833 116.238 15.9674 116.238 23.9953C116.238 32.0233 122.28 38.317 130 38.317C137.716 38.317 143.762 32.028 143.762 23.9953C143.762 15.9674 137.72 9.67833 130 9.67833ZM71.2587 9.67833C68.1958 9.67833 65.4079 10.676 63.2681 12.5128L62.6527 10.3357H57.2448V37.7063H64.1259V22.8345C64.1259 19.669 66.2471 16.4615 70.2984 16.4615C73.4685 16.4615 75.3566 18.6946 75.3566 22.4289V37.711H82.2377V21.9254C82.2377 14.4849 77.9301 9.67833 71.2587 9.67833Z"
      fill="#404553"
    />
    <path
      d="M0 25.1375C0 38.0047 10.9371 48 23.6503 48C36.9604 48 47.7482 37.2634 47.7482 24.1492C47.7482 16.4802 44.0373 9.74825 38.5455 5.24942L34.5361 12.1772C37.8508 14.9977 40.1259 19.352 40.1259 24.2517C40.1259 33.1562 32.7552 40.4802 23.6503 40.4802C14.5967 40.4802 7.22144 33.1562 7.22144 24.0047C7.22144 22.9138 7.31935 21.8275 7.51981 20.7879L0 25.1375ZM31.0723 1.18881C28.7972 0.344988 26.7692 0 24.7413 0C23.2075 0 21.8695 0.195804 20.8811 0.39627L15.7343 9.3007C17.6131 8.21445 20.0373 7.61772 22.662 7.61772C24.1958 7.61772 25.5804 7.81352 27.0163 8.20979L31.0723 1.18881Z"
      fill="#404553"
    />
  </svg>,
  "SSsportUaeIcon"
);

export const AdidasUaeIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="32"
    viewBox="0 0 50 32"
    fill="none"
  >
    <g clip-path="url(#clip0_0_3)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.07 31.439L31.925 0L22.206 5.606L37.112 31.439H50.07ZM32.781 31.439L20.797 10.692L11.078 16.298L19.823 31.439H32.781ZM9.718 21.401L15.509 31.439H2.551L0 27.007L9.718 21.401Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_0_3">
        <rect width="50" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "AdidasUaeIcon"
);

export const PaymentReciept = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>,
  "PaymentReciept"
);
